import React, {useState} from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {Avatar, Box, makeStyles, Typography} from "@material-ui/core";
import Image from "material-ui-image";
import DogImg from "../../../Images/petDogNew.svg";

interface AlertDialogProps {
    open: boolean,
    setOpen: (boolean) => void,
    onConfirm: () => void,
}

const useStyle = makeStyles(() => ({
    dialog: {
        padding: 20,
    },
    logo: {
        width: 80,
        height: 80,
        boxSizing: "border-box",
        position: "relative",
        backgroundColor: "#fafafa",
        margin: "0 auto 20px"
    },
}));

const AlertDialog: React.FC<AlertDialogProps> = ({open, setOpen, onConfirm}) => {
    const classes = useStyle();

    const handleClose = () => {
        localStorage.setItem("locationAccess", "false");
        setOpen(false);
    };

    const handleConfirm = () => {
        localStorage.setItem("locationAccess", "true");
        onConfirm();
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                classes={{paper: classes.dialog}}
                disableEnforceFocus
            >
                <DialogTitle>
                    <Avatar variant="square" className={classes.logo}>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width="80px"
                            height="80px"
                        >
                            <Image
                                imageStyle={{
                                    objectFit: "contain",
                                }}
                                src={DogImg}
                                style={{width: "100%"}}
                            />
                        </Box>
                    </Avatar>

                    <Typography align="center" variant="h3">
                        Access all available <br/>
                        appointment types for<br/>
                        your location <br/>
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography align="center">
                            Hello Ralphie uses your location to identify <br/>
                            which appointment types are legally <br/>
                            allowed and pair you with a vet in your state <br/>
                            when necessary.<br/>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box margin="0 auto">
                        <Button
                            onClick={handleConfirm}
                            color="secondary"
                            variant="contained"
                            autoFocus>
                            Agree
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AlertDialog;
